import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ProsConsEmbed from '../components/Exercise/ProsConsEmbed.jsx';

export const ProsConsNode = Node.create({
  name: 'prosConsExercise',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      topic: {
        default: '',
      },
      cefr: {
        default: 'B1',
      },
      pros: {
        default: [],
        parseHTML: (el, context) => {
          const pros = (context && context.pros) || [];
          const val = el.getAttribute('data-pros');
          if (!val) return pros;
          try {
            const arr = JSON.parse(val);
            return Array.isArray(arr) ? arr : typeof arr === 'string' ? [arr] : [];
          } catch {
            return pros;
          }
        },
        renderHTML: attrs => (attrs.pros && attrs.pros.length > 0 ? { 'data-pros': JSON.stringify(attrs.pros) } : {})
      },
      cons: {
        default: [],
        parseHTML: (el, context) => {
          const cons = (context && context.cons) || [];
          const val = el.getAttribute('data-cons');
          if (!val) return cons;
          try {
            const arr = JSON.parse(val);
            return Array.isArray(arr) ? arr : typeof arr === 'string' ? [arr] : [];
          } catch {
            return cons;
          }
        },
        renderHTML: attrs => (attrs.cons && attrs.cons.length > 0 ? { 'data-cons': JSON.stringify(attrs.cons) } : {})
      },
      hideInstructions: {
        default: false,
      },
      pairs: {
        default: 5,
      },
      exerciseId: {
        default: null,
        parseHTML: element => element.getAttribute('data-exercise-id') || null,
        renderHTML: attributes => attributes.exerciseId ? { 'data-exercise-id': attributes.exerciseId } : {}
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="pros-cons-exercise"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'pros-cons-exercise' })];
  },

  addCommands() {
    return {
      insertProsConsExercise:
        (attributes = {}) =>
        ({ commands }) => {
          const pros = Array.isArray(attributes.pros)
            ? attributes.pros.map(String)
            : typeof attributes.pros === 'string'
              ? [attributes.pros]
              : [];
          const cons = Array.isArray(attributes.cons)
            ? attributes.cons.map(String)
            : typeof attributes.cons === 'string'
              ? [attributes.cons]
              : [];
          return commands.insertContent({
            type: this.name,
            attrs: {
              ...attributes,
              pros,
              cons,
            },
          });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(ProsConsEmbed);
  },
});

